export default __webpack_public_path__ + "static/media/ohjaa_favicon.7fb4f163.ico";